const LiabilityValues = {
    ONE_MILLION: '1000000',
    TWO_MILLION: '2000000',
};

export default LiabilityValues;
